import React, { Component, PropTypes } from "react";

import LeftNavContainer from "./LeftNavContainer";
import NavItemCharts from "./NavItemCharts";
import NavItemAlgorithm from "./NavItemAlgorithm";
import NavItemManageAlerts from "./NavItemManageAlerts";
import NavItemContactUs from "./NavItemContactUs";
import NavItemComingSoon from "./NavItemComingSoon";

const LeftNav = (props) =>
	<LeftNavContainer>
		<NavItemCharts size={props.size} />
		<NavItemAlgorithm size={props.size} />
		<NavItemManageAlerts size={props.size} />
		<NavItemContactUs size={props.size} />
		<NavItemComingSoon size={props.size} />
	</LeftNavContainer>;

LeftNav.propTypes = {
	size: PropTypes.number,
};

export default LeftNav;



/** WEBPACK FOOTER **
 ** ./src/scripts/components/leftnav/LeftNav.jsx
 **/